import mitt from "mitt";
import type { FC, PropsWithChildren } from "react";
import { createContext } from "react";

import type { SiteSdk } from "~/core/site-sdk";
import { Modals } from "~/widgets/auth-modals/modals";

export type AuthModalsContext = {
  open: (name: AuthModalName) => void;
  close: () => void;
};

// eslint-disable-next-line react-refresh/only-export-components
export const authModalsProvider = createContext<AuthModalsContext | null>(null);

export type Events = {
  open: AuthModalName;
  close: null;
};

export type AuthModalName =
  | "login"
  | "register"
  | "restore"
  | "successRestore"
  | "successRegistration"
  | "fastRegistration"
  | "valueChainRegistration"
  | "valueChainLogin"
  | "otpRegistration"
  | "preDepBonus";

const emitter = mitt<Events>();

export type AuthModalsProviderProps = PropsWithChildren<{
  siteSdk: SiteSdk;
  playerId?: string | undefined;
}>;

export const AuthModalsProvider: FC<AuthModalsProviderProps> = ({
  children,
  ...props
}) => {
  const close = (): void => {
    emitter.emit("close", null);
  };

  const open = (name: AuthModalName): void => {
    emitter.emit("open", name);
  };
  return (
    <authModalsProvider.Provider
      value={{
        open,
        close,
      }}
    >
      <>
        {children}
        <Modals emitter={emitter} {...props} />
      </>
    </authModalsProvider.Provider>
  );
};
